import * as React from 'react'

import Select from 'react-select'

const map = require('lodash/map')
const find = require('lodash/find')
const filter = require('lodash/filter')
const includes = require('lodash/includes')

export type SelectType = 'normal' | 'orange' | 'applications'

type CustomSelectProps = {
  style?: any
  value?: any
  options: any
  type?: SelectType
  isMulti?: boolean
  tabIndex?: string
  disabled?: boolean
  placeholder?: string
  key?: string | number
  isSearchable?: boolean
  placeholderStyle?: any
  valueContainerStyle?: any
  getOptionLabel?: (option: any) => string
  getOptionValue?: (option: any) => string
  onChange: (value: number|string|number[]|string[]) => void
}

class CustomSelect extends React.Component<CustomSelectProps> {
  handleChange(value) {
    const { isMulti, onChange } = this.props

    let newValue
    if (isMulti) {
      newValue =  map(value, option => this.getOptionValue(option))
    }
    else {
      newValue = this.getOptionValue(value)
    }

    onChange(newValue)
  }

  getOptionValue(option) {
    const { getOptionValue } = this.props

    return getOptionValue ? getOptionValue(option) : option.value
  }

  render() {
    const {
      key,
      type,
      style,
      value,
      isMulti,
      options,
      disabled,
      tabIndex,
      placeholder,
      isSearchable,
      getOptionLabel,
      getOptionValue,
      placeholderStyle,
      valueContainerStyle
    } = this.props

    const fontColor = type === 'orange' ? 'white' : '#636363'
    const backgroundColor = type === 'orange' ? TENANT_PRIMARY_COLOR : (type === 'applications' ? '#F4F4F4' : 'transparent')

    const aditionalDropdownIndicatorOptions =
      type !== 'applications'
        ? {}
        : {
            width: '26px',
            height: '26px',
            display: 'flex',
            borderRadius: '50%',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor : 'white'
          }

    const aditionalInputOptions =
      type !== 'applications'
        ? {}
        : {
          fontSize: '16px',
          color: undefined
        }

    let aditionalStyles = {}
    if (type === 'applications') {
      aditionalStyles = {
        menu: (provided, state) => ({
          ...provided,
          padding: '5px 7px',
          marginTop: '10px',
          borderRadius: '5px',
          backgroundColor: '#3a393b'
        }),
        option: (provided, state) => {
          return {
          ...provided,
          color: 'white',
          borderRadius: '3px',
          backgroundColor:
            state.isFocused
              ? '#494949'
              : state.isSelected
                ? '#595959'
                : 'transparent',

          ':active': {
            ...provided[':active'],
            backgroundColor: state.isSelected
              ? '#595959'
              : '#494949'
          }
        }}
      }
    }

    let customStyles = {}
    if (type) {
      customStyles = {
        menuPortal: provided => ({
          ...provided,
          zIndex: 99999
        }),
        control: (provided, state) => {
          const border = type === 'applications' && (state.isFocused || state.isSelected) ? `px solid ${TENANT_PRIMARY_COLOR}` : 'none'

          return {
            ...provided,
            border,
            borderRadius: 6,
            backgroundColor,
            boxShadow: 'none',
            minHeight: '30px',
            paddingRight: '5px',
            height: type === 'applications' ? '46px' : '30px',
            ...style
          }
        },
        input: (provided, state) => ({
          ...provided,
          outline: 'none',
          color: 'transparent',
          textShadow: '0 0 0 gray',

          '&:focus': {
            outline: 'none'
          },
          ...aditionalInputOptions
        }),
        dropdownIndicator: (provided, state) => ({
          ...provided,
          padding: 0,
          color: fontColor,
          ...aditionalDropdownIndicatorOptions
        }),
        indicatorSeparator: (provided, state) => ({
          ...provided,
          display: 'none'
        }),
        valueContainer: (provided, state) => ({
          ...provided,
          textAlign: 'center',
          padding: '0 3px 0 5px',
          ...valueContainerStyle
        }),
        placeholder: (provided, state) => ({
          ...provided,
          width: '100%',
          color: fontColor,
          fontWeight: 'bold',
          ...placeholderStyle
        }),
        singleValue: (provided, state) => ({
          ...provided,
          width: '100%',
          color: fontColor,
          fontWeight: 'bold'
        }),
        ...aditionalStyles
      }
    }
    else {
      customStyles = {
        menuPortal: provided => ({
          ...provided,
          zIndex: 999999
        })
      }
    }

    let selectedValue
    if (!isMulti) {
      selectedValue = find(options, option => this.getOptionValue(option) === value)
    }
    else {
      selectedValue = filter(options, option => includes(value, this.getOptionValue(option)))
    }

    return (
      <Select
        key={key}
        isMulti={isMulti}
        tabIndex={tabIndex}
        styles={customStyles}
        isDisabled={disabled}
        options={options || []}
        placeholder={placeholder}
        isSearchable={isSearchable}
        value={selectedValue || null}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        menuPortalTarget={document.querySelector('body')}
        onChange={option => {
          this.handleChange(option)
        }}
      />
    )
  }
}

export default CustomSelect



// WEBPACK FOOTER //
// ./src/common/CustomSelect.component.tsx